import { render, staticRenderFns } from "./NetProfit.vue?vue&type=template&id=dfe5ea48"
import script from "./NetProfit.vue?vue&type=script&lang=js"
export * from "./NetProfit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports